<template>
	<div>
		<div class="searchTop space_between">
			<el-form inline class="el-form">
				<el-form-item>
					<el-date-picker v-model="datePicker" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" size="small" :clearable="false">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryApi.companyId" filterable clearable size="small" placeholder="请选择媒体公司"
					@change="companySelectChange" style="width: 280px;">
						<el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryApi.platformId" filterable clearable size="small" @change="networkOptionsChange" 
					placeholder="请选择广告网络" style="width: 280px;">
						<el-option v-for="item in networkOptions" :key="item.platformId" :label="item.label" :value="item.platformId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryApi.platformNetworkId" filterable clearable size="small"
					placeholder="请选择账号名称" style="width: 280px;">
						<el-option v-for="item in accountOptions" :key="item.value" :label="item.label" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryApi.os" filterable clearable size="small" placeholder="请选择操作系统"
					style="width: 280px;">
						<el-option v-for="item in osOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
						<el-select v-model="appSelectForm" clearable @change="appSeleteChange" size="small" value-key="value"
							popper-class="appNameIdOptions" :popper-append-to-body="false" filterable placeholder="请选择应用"
							:remote-method="appRemoteMethod" :loading="appRemoteLoading" remote @clear="getMediaAppOption()"
							style="width: 280px;">
							<el-option v-for="item in mediaAppOptions" :key="item.value"
								:value="item" :label="`应用：${item.label} | ${item.value}`">
								<div class="selectTemp2">
									<div class="selectAppName">{{item.label}}</div>
									<div class=""></div>
									<div class="selectAppId flex_start">
										<div>{{item.value}}</div>
										<img @click.stop="copyName(item.value)" src="../../assets/icon/copy.png" alt="" />
									</div>
								</div>
							</el-option>
						</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryApi.adType" filterable clearable size="small" placeholder="请选择广告类型"
					style="width: 280px;">
						<el-option v-for="item in adTypeOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="adsSelectFormChannel" clearable @change="channelAdsSeleteChange" size="small"
					value-key="value" popper-class="appNameIdOptions" :popper-append-to-body="false" filterable
					@clear="getChannelAdsOption(2)" :remote-method="channelAdsRemoteMethod" :loading="adsRemoteLoading" remote
					placeholder="请选择广告源" style="width: 280px;">
							<el-option v-for="(item,index) in channelAdsOptions" :key="index" :label="`广告源：${item.label} | ${item.value}`"
								:value="item">
								<div class="selectTemp2">
									<div class="selectAppName">{{item.label}}</div>
									<div class=""></div>
									<div class="selectAppId flex_start">
										<div>{{item.value}}</div>
										<img @click.stop="copyName(item.value)" src="../../assets/icon/copy.png" alt="" />
									</div>
								</div>
							</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="adsSelectFormMedia" clearable @change="mediaAdsSeleteChange" size="small"
					value-key="value" popper-class="appNameIdOptions" :popper-append-to-body="false" filterable
					@clear="getMediaAdsOption(2)" :remote-method="mediaAdsRemoteMethod" :loading="adsRemoteLoading" remote
					placeholder="请选择聚合广告位" style="width: 280px;">
							<el-option v-for="(item,index) in mediaAdsOptions" :key="index" :label="`${item.label} | ${item.value}`"
								:value="item">
								<div class="selectTemp2">
									<div class="selectAppName">{{item.label}}</div>
									<div class=""></div>
									<div class="selectAppId flex_start">
										<div>{{item.value}}</div>
										<img @click.stop="copyName(item.value)" src="../../assets/icon/copy.png" alt="" />
									</div>
								</div>
							</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input clearable size="small" placeholder="请输入预算名称" v-model="queryApi.source"
					style="width: 280px;"></el-input>
				</el-form-item>
			</el-form>
			<div class="menu-right">
					<el-button @click="searchReset" size="small">重置</el-button>
					<div></div>
					<el-button type="primary" @click="apiQuery" size="small"> 查询</el-button>
				</div>
		</div>
		<!-- table表格 -->
		<div class="tableBox">
			<div class="menu-right-table">
				<el-button type="primary" size="small" @click="appExport">导出</el-button>
			</div>
			<el-table :max-height="560" :header-cell-style="{color:'#333333',background:'#EAEFF5'}" :data="tableData"
				class="el_table" ref="multipleTable">
				<el-table-column prop="dateTime" label="日期" min-width="150"></el-table-column>
				<!-- <el-table-column prop="time" label="时间戳"></el-table-column> -->
				<el-table-column prop="" label="媒体公司/OS/APP名称" min-width="160">
					<template slot-scope="scope">
						<el-popover placement="top" width="200" trigger="hover" class="el_popover" style="margin-left: auto;">
							<div>{{scope.row.companyName}}</div>
							<div>{{scope.row.os}}</div>
							<div>{{scope.row.appName}}</div>
							<div class="" slot="reference">
								<div class="ellipsis">{{scope.row.companyName}}</div>
								<div>{{scope.row.os}}</div>
								<div class="ellipsis">{{scope.row.appName}}</div>
							</div>
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column prop="" label="广告位类型/聚合广告位" min-width="160">
					<template slot-scope="scope">
						<div>{{scope.row.adType}}</div>
						<div class="ellipsis">{{scope.row.mediaAdName}}</div>
						<div>{{scope.row.mediaAdId}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="" label="广告网络/广告源" min-width="150">
					<template slot-scope="scope">
						<div>{{scope.row.platformNetworkName}}</div>
						<div class="ellipsis">{{scope.row.platformAdName}}</div>
						<div>{{scope.row.platformAdId}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="source" label="预算名称" min-width="100"></el-table-column>
				<el-table-column prop="winPrice" label="媒体出价(分)" min-width="100"></el-table-column>
				<el-table-column prop="bidPrice" label="总出价(分)" min-width="100"></el-table-column>
				<el-table-column prop="" label="素材图片/视频" min-width="130">
					<template slot-scope="scope">
						<div class="flex_start">
							<div
								v-if="scope.row.materialVideoUrl"
								class="material-video-thumb"
								@click="openVideoPreview(scope.row)"
							>
								<img
									v-if="scope.row.materialUrl"
									class="upload_img"
									:src="scope.row.materialUrl"
									alt="视频封面"
								/>
								<div v-else class="upload_img material-video-placeholder">
									<i class="el-icon-video-camera"></i>
								</div>
								<div class="material-video-play">
									<i class="el-icon-video-play"></i>
								</div>
							</div>
							<el-image
								v-else-if="scope.row.materialUrl"
								class="upload_img"
								:src="scope.row.materialUrl"
								:preview-src-list="[scope.row.materialUrl]"
							></el-image>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="" label="DP链接" min-width="140">
					<template slot-scope="scope">
						<!-- <el-popover placement="top" width="200" trigger="hover" class="el_popover" style="margin-left: auto;" v-if="scope.row.tripleDpLink">
							<div>{{scope.row.tripleDpLink}}</div>
							<div class="linkTxtImg flex_start" slot="reference">
								<div class="ellipsis_2">{{scope.row.tripleDpLink}}</div>
								<img @click.stop="copyName(scope.row.tripleDpLink)" src="../../assets/icon/copy.png" alt="" />
							</div>
						</el-popover> -->
						<div class="linkTxtImg flex_start" v-if="scope.row.polymerDpLink">
							<div class="ellipsis_2">{{scope.row.polymerDpLink}}</div>
							<img @click.stop="copyName(scope.row.polymerDpLink)" src="../../assets/icon/copy.png" alt="" />
						</div>
						<div v-else>-</div>
					</template>
				</el-table-column>
				<el-table-column prop="" label="落地页链接" min-width="140">
					<template slot-scope="scope">
						<div v-if="scope.row.adClickUrl" class="linkTxtImg flex_start landing-page-link-row">
							<a
								class="landing-page-link ellipsis_2"
								:href="scope.row.adClickUrl"
								target="_blank"
								rel="noopener noreferrer"
								:title="scope.row.adClickUrl"
							>{{ scope.row.adClickUrl }}</a>
							<img @click.stop="copyName(scope.row.adClickUrl)" src="../../assets/icon/copy.png" alt="" />
						</div>
						<div v-else>-</div>
					</template>
				</el-table-column>
				<el-table-column prop="materialTitle" label="素材标题描述" min-width="140">
					<template slot-scope="scope">
						<el-popover placement="top" width="200" trigger="hover" class="el_popover" style="margin-left: auto;" v-if="scope.row.materialTitle">
							<div>{{scope.row.materialTitle}}</div>
							<div class="linkTxtImg flex_start" slot="reference">
								<div class="ellipsis_2">{{scope.row.materialTitle}}</div>
							</div>
						</el-popover>
						<div v-else>-</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="paging" style="display: flex;justify-content: flex-end;margin-top: 20px;">
				<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</div>
		<el-dialog
			title="视频预览"
			:visible.sync="videoPreviewVisible"
			width="560px"
			append-to-body
			@closed="onVideoPreviewDialogClosed"
		>
			<video
				v-if="previewVideoUrl"
				ref="materialPreviewVideo"
				class="material-preview-video"
				controls
				playsinline
				:src="previewVideoUrl"
				:poster="previewVideoPoster || undefined"
			></video>
		</el-dialog>
	</div>
</template>

<script>
	export default{
		data() {
			return {
				queryApi: {
					companyId: '',
					platformNetworkId: '',
					platformAdsId: '',
					mediaAppId: '',
					mediaAdId: '',
					os: '',
					type: '',
				},
				datePicker: [], // 日期选择
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				companyOptions: [], //公司下拉选择列表
				selectedCompanyLabel: '', // 当前选中公司的名称，仅用于查询应用下拉
				osOptions: this.$api.osOptions, // OS下拉选择列表
				mediaAppOptions: [], // 媒体APP下拉选择列表
				appSelectForm: {}, // 媒体APP下拉选中值
				appRemoteLoading: false,
				adTypeOptions: this.$api.adsTypeOptions, // 广告类型
				adsSelectFormChannel: {}, //渠道广告位下拉选中数据
				channelAdsOptions: [], //渠道广告位下拉列表
				adsRemoteLoading: false,
				networkOptions: [], // 广告网络下拉列表
				accountOptions: [], // 账号名称下拉选择列表
				adsSelectFormMedia: {}, //聚合广告位下拉选中数据
				mediaAdsOptions: [], //聚合广告位下拉列表
				videoPreviewVisible: false,
				previewVideoUrl: '',
				previewVideoPoster: '',
			}
		},
		mounted(){
			this.dateInit()
			this.getCompanyOption();
			this.getNetworkOtions();
			this.getAccountOptions();
			this.getChannelAdsOption(2, null);
			this.getMediaAdsOption(2, null);
			this.getMediaAppOption();
			this.getTableData();
		},
		methods: {
			// 日期选择器初始化
			dateInit() {
				const d = new Date();
				const s = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
				this.datePicker = [s, s];
			},
			appendTopFilterToReportBody(data) {
				if (this.appSelectForm && this.appSelectForm.value) {
					data.appId = this.appSelectForm.value
				}
				if (this.adsSelectFormChannel && this.adsSelectFormChannel.value) {
					data.platformAdId = this.adsSelectFormChannel.value
				}
				if (this.adsSelectFormMedia && this.adsSelectFormMedia.value) {
					data.mediaAdId = this.adsSelectFormMedia.value
				}
			},
			async getTableData() {
				let data = {
					linkType: 2,
					startDate: this.datePicker[0],
					endDate: this.datePicker[1],
					...this.queryApi,
					pageNum: this.currentPage,
					pageSize: this.pageSize,
				}
				this.appendTopFilterToReportBody(data)
				let res = await this.$http.post(this.$api.operationalAnalysis.aggregationAnalysLinkList,data);
				if (res.code == 200||res.code == 1) {
					const d = res.data || {}
					const list = [...(d.list || [])]
					this.tableData = list
					this.total = d.totalRecord
				}
			},
			// 渠道广告位下拉选中
			channelAdsSeleteChange(e) {
				if (e && e.value) {
					this.adsSelectFormChannel = e
				}
			},
			channelAdsRemoteMethod(query) {
				clearTimeout();
				setTimeout(() => {
					this.adsRemoteLoading = true
					this.getChannelAdsOption(2, query)
				}, 300)
			},
			// 获取公司下拉列表
			async getCompanyOption() {
				let res = await this.$http.get(this.$api.common.companyOption);
				this.companyOptions = res.data
			},
			// 公司下拉列表选择
			companySelectChange(companyId){
				const selectedCompany = this.companyOptions.find(item => item.value === companyId)
				this.selectedCompanyLabel = selectedCompany ? selectedCompany.label : ''
				this.appSelectForm = {}
				this.mediaAppOptions = []
				this.getMediaAppOption();
			},
			// 获取媒体APP下拉列表
			async getMediaAppOption(query = null) {
				let data = {
					mediaCompany: this.selectedCompanyLabel,
					appId: query,
				}
				let res = await this.$http.get(this.$api.common.mediaAppOption,data);
				this.appRemoteLoading = false
				this.mediaAppOptions = res.data
			},
			appSeleteChange(e) {
				this.appSelectForm = e
			},
			appRemoteMethod(query){
				clearTimeout();
				setTimeout(()=>{
					this.appRemoteLoading = true
					this.getMediaAppOption(query)
				},300)
			},
			mediaAdsRemoteMethod(query) {
				clearTimeout();
				setTimeout(() => {
					this.adsRemoteLoading = true
					this.getMediaAdsOption(2, query)
				}, 300)
			},
			mediaAdsSeleteChange(e) {
				if (e && e.value) {
					this.adsSelectFormMedia = e
				}
			},
			// 获取聚合广告位下拉列表
			async getMediaAdsOption(type, query = null) {
				let data = {
					adsName: query
				}
				let res = await this.$http.get(this.$api.common.mediaAdsOption, data);
				this.adsRemoteLoading = false
				this.mediaAdsOptions = res.data
			},
			// 获取渠道广告位下拉列表
			async getChannelAdsOption(type, query = null) {
				let data = {
					adsId: query
				}
				let res = await this.$http.post(this.$api.common.channelAdsOption, data);
				this.adsRemoteLoading = false
				this.channelAdsOptions = res.data
			},
			// 获取配置后的广告网络下拉选择列表
			async getNetworkOtions() {
				let res = await this.$http.get(this.$api.mediaAd.networkOptionDistinct);
				this.networkOptions = res.data
			},
			networkOptionsChange(e){
				this.accountOptions = []
				this.queryApi.platformNetworkId = ''
				if(e){
					this.getAccountOptions(e);
				}else{
					this.getAccountOptions();
				}
			},
			// 获取账号名称下拉列表
			async getAccountOptions(platformId){
				let data = {platformId: platformId}
				let res = await this.$http.get(this.$api.mediaAd.networkAccountOption,data);
				this.accountOptions = res.data
			},
			// 复制APP名称
			async copyName(txt) {
				try {
					// 使用现代异步 API
					await navigator.clipboard.writeText(txt)
					this.$message.success('复制成功');
				} catch (err) {
					// 某些环境（比如 HTTP 或非安全上下文）不支持 navigator.clipboard
					// 这里可做回退方案：
					this.fallbackCopy(txt)
				}
			},
			fallbackCopy(text) {
				const input = document.createElement('input')
				input.value = text
				document.body.appendChild(input)
				input.select()
				document.execCommand('copy')
				document.body.removeChild(input)
				this.$message.success('复制成功');
			},
			handleSizeChange(val) {
				this.currentPage = 1
				this.pageSize = val
				this.getTableData();
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getTableData();
			},
			searchReset() {
				this.currentPage = 1
				this.pageSize = 10
				this.queryApi = { 
					isMedia: false,
					companyId: '',
					platformNetworkId: '',
					platformAdsId: '',
					mediaAppId: '',
					os: '',
					type: '',
				}
				this.selectedCompanyLabel = ''
				this.getTableData()
			},
			apiQuery() {
				this.currentPage = 1
				this.getTableData()
			},
			// 导出 table 为 Excel（与接口导出命名一致：yyyyMMdd_HHmm + 渠道分时报表对比.xlsx）
			exportToExcelFromDOM() {
				const tableRef = this.$refs.multipleTable
				if (!tableRef || !tableRef.$el) {
					this.$message.warning('表格未就绪')
					return
				}
				const tableEl = tableRef.$el
				const rows = tableEl.querySelectorAll('.el-table__body-wrapper tbody tr')
				const data = []
			
				const headerEls = tableEl.querySelectorAll('.el-table__header th')
				const headers = Array.from(headerEls).map((th) => th.innerText.trim())
				data.push(headers)
				// const rowData = Array.from(cells).map(cell => {
				// 	// 获取单元格内所有非隐藏元素的文本（包括 v-for 产生的多个 span）
				// 	// 简单做法：取 cell.innerText，它会自动合并所有子元素的文本
				// 	// 如果希望自定义分隔符，可以手动提取各个子元素
				// 	const spans = cell.querySelectorAll('.hobby-tag') // 你的具体 class
				// 	if (spans.length) {
				// 		return Array.from(spans).map(span => span.innerText.trim()).join('、')
				// 	}
				// 	return cell.innerText.trim()
				// })
				rows.forEach((row) => {
					const cells = row.querySelectorAll('td')
					const rowData = Array.from(cells).map((cell) => {
						const spans = cell.querySelectorAll('.updownText')
						if (spans.length) {
							// Excel 单元格内换行使用 \n（CHAR(10)）；与顿号「、」拼接相比，配合行高在表格中更易读
							return Array.from(spans)
								.map((span) => span.innerText.trim())
								.filter(Boolean)
								.join('\n')
						}
						return cell.innerText.trim()
					})
					data.push(rowData)
				})
				const ws = XLSX.utils.aoa_to_sheet(data)
				// this.applyExcelMultilineRowHeights(ws)
				const wb = XLSX.utils.book_new()
				XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
				const fileName = `${this.getExportFileNamePrefix()}渠道分时报表对比.xlsx`
				XLSX.writeFile(wb, fileName, { cellStyles: true })
			},
			getExportFileNamePrefix() {
				const d = new Date()
				const pad = (n) => String(n).padStart(2, '0')
				return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(d.getHours())}:${pad(
					d.getMinutes()
				)}`
			},
			// 导出
			async appExport() {
				let data = {
					startDate: this.datePicker[0],
					endDate: this.datePicker[0],
					...this.queryApi,
					pageNum: this.currentPage,
					pageSize: this.pageSize,
				}
				this.appendTopFilterToReportBody(data)
				let res = await this.$http.post(this.$api.operationalAnalysis.aggregationAnalysLinkExport, data, 1);
				const time = this.getTimeFun();
				this.$http.downloads(res, `${time}三方回传链接数据.xls`)
			},
			openVideoPreview(row) {
				this.previewVideoUrl = row.materialVideoUrl || ''
				this.previewVideoPoster = row.materialUrl || ''
				this.videoPreviewVisible = true
			},
			onVideoPreviewDialogClosed() {
				const el = this.$refs.materialPreviewVideo
				if (el && typeof el.pause === 'function') {
					try {
						el.pause()
					} catch (e) {
						// ignore
					}
				}
				this.previewVideoUrl = ''
				this.previewVideoPoster = ''
			},
			// 下载选择的日期
			getTimeFun() {
				if (!this.datePicker || !this.datePicker.length) {
					return ''
				}
				var startMonth = this.datePicker[0];
				var endMonth = this.datePicker[1];
				// 如果开始时间和结束时间相同，则以开始时间为主
				if (startMonth === endMonth) {
					endMonth = ''
				};
				return startMonth + "-" + endMonth;
			},
		}
	}
</script>

<style scoped>
	.searchTop{
		background: #ffffff;
		padding: 20px;
	}
	.el-form {
		align-items: center;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		margin-bottom: 25px;
	}
	.searchTop .el-form {
		margin-bottom: 0;
	}
	
	/deep/ .el-form-item {
		margin-right: 10px !important;
		margin-bottom: 0px;
	}
	
	.menu-right {
		margin-left: auto;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
	
	.tableBox {
		margin-top: 10px;
		background: #ffffff;
		padding: 16px;
	}
	.menu-right-table{
		margin-bottom: 20px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.upload_img {
		width: 120px;
		height: 120px;
		margin: 0px 0;
		position: relative;
	}
	.material-video-thumb {
		position: relative;
		display: inline-block;
		cursor: pointer;
	}
	.material-video-thumb .upload_img {
		display: block;
		object-fit: cover;
	}
	.material-video-placeholder {
		background: #eef1f6;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #909399;
		font-size: 40px;
	}
	.material-video-play {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		font-size: 44px;
		color: rgba(255, 255, 255, 0.95);
		text-shadow: 0 0 10px rgba(0, 0, 0, 0.45);
		pointer-events: none;
	}
	.material-preview-video {
		width: 100%;
		max-height: 70vh;
		display: block;
		background: #000;
	}
	.linkTxtImg{
		align-items: center;
	}
	.linkTxtImg img{
		width: 14px;
		height: 14px;
		margin-left: 2px;
		cursor: pointer;
	}
	.landing-page-link-row .landing-page-link {
		flex: 1;
		min-width: 0;
		color: #409eff;
		text-decoration: none;
	}
	.landing-page-link-row .landing-page-link:hover {
		text-decoration: underline;
	}
	
	/deep/.appNameIdOptions .el-select-dropdown__item {
		height: 48px !important;
		line-height: 48px !important;
	}
	.selectTemp2 {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	.selectAppName,
	.selectAppId {
		font-size: 12px;
		color: #333333;
		line-height: 20px;
	}
	
	.selectAppId {
		color: #999999;
		align-items: center;
	}
	
	.selectAppId img {
		width: 14px;
		height: 14px;
		margin-left: 3px;
	}
</style>
